import { useCallback } from "react";
import { useNavigate, useParams } from "react-router";

import { routes } from "~/app/routes/web-routes.ts";
import { useCustomerSelection } from "~/shared/hooks/use-customer-selection.ts";

export const useAddressBookNavigation = () => {
	const { addressBookItemId } = useParams();
	const navigate = useNavigate();

	const customerNav = useCustomerSelection({
		baseRoute: routes.addressBook,
		customerRoute: routes.addressBookWithCustomer,
	});

	const selectedAddressBookItem = addressBookItemId
		? Number(addressBookItemId)
		: undefined;

	const handleSelectAddressBookItem = useCallback(
		(id: number | undefined) => {
			if (!customerNav.selectedCustomer) return;

			if (id) {
				navigate(
					routes.addressBookEdit
						.replace(":customerId", String(customerNav.selectedCustomer.id))
						.replace(":addressBookItemId", String(id)),
				);
			} else {
				navigate(
					routes.addressBookWithCustomer.replace(
						":customerId",
						String(customerNav.selectedCustomer.id),
					),
				);
			}
		},
		[navigate, customerNav.selectedCustomer],
	);

	return {
		...customerNav,
		selectedAddressBookItem,
		handleSelectAddressBookItem,
	};
};
